import useInView from "react-cool-inview";
const NeedWEb = () => {
  const { observe, unobserve, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });
  return (
    <div className="section-gap mt-3 why-next-med d-none" ref={observe}>
      {inView && (
        <div className="container">
          <div className="section-title text-white happy-customers-title">
            <h2 className="text-testimonial">Why Nextmed</h2>
          </div>
          <hr />

          <div className="row pt-3">
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/1.gif" className="img-fluid" />
                </div>
                <p>Free ongoing Care</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/2.gif" className="img-fluid" />
                </div>
                <p>Same-day testing</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/4.gif" className="img-fluid" />
                </div>
                <p>At-home visits</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/5.gif" className="img-fluid" />
                </div>
                <p> Free ongoing Care</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/6.gif" className="img-fluid" />
                </div>
                <p> 4,500 testing centers</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/7.gif" className="img-fluid" />
                </div>
                <p>Insurance reimbursable</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/9.gif" className="img-fluid" />
                </div>
                <p> Includes virtual visit</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="why-nextmed-box">
                <div className="icon">
                  <img src="/why_section/10.gif" className="img-fluid" />
                </div>
                <p>Most comprehensive Testing possible</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default NeedWEb;
